import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import * as spacing from 'styles/spacing'
import { white } from 'styles/colors'
import { fontWeights, fontSizes } from 'styles/typography'
import { media } from 'styles/media'

import Icon from 'components/Icon'
import CloseSmall from 'icons/close-small.svg'

const Container = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  text-align: center;
  padding: ${spacing.medium} ${spacing.xLarge};
  background-color: #0a0b0c;
  color: ${white};
`

const Heading = styled.p`
  font-weight: ${fontWeights.bold};
  display: block;
  margin-bottom: 0;
`

const Action = styled.button`
  text-decoration: underline;
  font-weight: ${fontWeights.bold};
  margin-top: ${spacing.tiny};
`

const Description = styled.p`
  font-size: ${fontSizes.small};
  margin-top: ${spacing.small};
  margin-bottom: 0;

  button {
    text-decoration: underline;
  }
`

const Close = styled.button`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  padding: ${spacing.tiny};

  ${media.medium`
    padding: ${spacing.small};
  `};
`

const PriceIncreaseBanner = () => {
  const [expanded, setExpanded] = useState(false)
  const [visible, setVisible] = useState(true)

  const hideBanner = () => {
    setVisible(false)
    localStorage.setItem('hideBanner', true)
  }

  useEffect(() => {
    setVisible(!localStorage.getItem('hideBanner'))
  }, [])

  if (visible) {
    return (
      <>
        <Container>
          <Heading>
            OUR PRICING HAS CHANGED - On October 5th, the price of our pods will increase by $1, in stores and on
            vuse.com.
          </Heading>
          {!expanded && <Action onClick={() => setExpanded(true)}>Learn more</Action>}
          {expanded && (
            <Description>
              This increase is part on our ongoing commitment to deliver innovative products, an exciting selection of
              new and unique flavours, personalized service, and overall the best possible vaping experience.{' '}
              <button onClick={() => setExpanded(false)}>Hide</button>
            </Description>
          )}
          <Close onClick={() => hideBanner()}>
            <Icon icon={<CloseSmall />} />
          </Close>
        </Container>
      </>
    )
  }
  return null
}

export default PriceIncreaseBanner
